exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VerifiedInfo-displayGrid-1V97m {\n\tdisplay: grid;\n\tgrid-template-columns: 30px auto;\n}\n\n.VerifiedInfo-displayFlex-3UoR5 {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\t-webkit-box-pack: justify;\n\t    -ms-flex-pack: justify;\n\t        justify-content: space-between;\n}\n\n.VerifiedInfo-infoPadding-w8nYF {\n\tpadding: 0px 24px 24px 24px;\n}\n\n.VerifiedInfo-tickIcon-1z93x {\n\twidth: 100%;\n\tmax-width: 12px;\n}\n\n.VerifiedInfo-googleIcon-1F7Ji{\n\twidth: 20px;\n}\n\n.VerifiedInfo-fbIcon-1FFtY{\n\twidth: 15px;\n}\n\n.VerifiedInfo-emailTop-1ie9O{\n\tposition: relative;\n\ttop: -2px;\n}\n\n.VerifiedInfo-veriffIconBox--jw4-{\n\twidth: 22px;\n\theight: 22px;\n}", ""]);

// exports
exports.locals = {
	"displayGrid": "VerifiedInfo-displayGrid-1V97m",
	"displayFlex": "VerifiedInfo-displayFlex-3UoR5",
	"infoPadding": "VerifiedInfo-infoPadding-w8nYF",
	"tickIcon": "VerifiedInfo-tickIcon-1z93x",
	"googleIcon": "VerifiedInfo-googleIcon-1F7Ji",
	"fbIcon": "VerifiedInfo-fbIcon-1FFtY",
	"emailTop": "VerifiedInfo-emailTop-1ie9O",
	"veriffIconBox": "VerifiedInfo-veriffIconBox--jw4-"
};